module.exports = __webpack_public_path__ + "img/exact.eb0fd686.png";